import { gql } from '__generated__';

export default gql(`
  query GetExportUrl($id: ID!) {
    export(id: $id) {
      id
      url
    }
  }
`);
